import { useTranslation } from 'next-i18next'
// import { Validator } from '@/utils'

/**
 * Custom hook for field validation
 * @returns Object with validation function
 */
export const useFieldValidation = () => {
  // const { t: tc } = useTranslation('connection')
  const { t: tp } = useTranslation('petsitter')

  /**
   * Checks a field value and returns an error message if invalid.
   * @param key - The field key.
   * @param value - The field value.
   * @returns An error message string or an empty string if valid.
   */
  const checkField = (key: string, value: any): string => {
    let error = ''

    switch (key) {
      case 'animals':
        if (!value || value.length === 0) {
          error = tp('reservations.newRequests.errors.noAnimals')
        }
        break
      // case 'description':
      //   if (!value) {
      //     error = 'Veuillez expliquer votre demande'
      //   } else if (!Validator.validate(value, Validator.defaultValidateTypes.lengthMin(5))) {
      //     error = tc('create-your-profile.description.errors.descriptionInvalid', {
      //       length: 5,
      //     })
      //   }
      //   break
      // case 'dateTimeInstances':
      //   if (!value || value.length === 0) {
      //     error = tp('reservations.newRequests.errors.noDateTimeInstances')
      //   }
      //   break
      case 'contact':
        if (!value || value.length === 0) {
          error = tp('reservations.newRequests.errors.noContacts')
        }
        break
      default:
        break
    }
    return error
  }

  return { checkField }
}
